import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { store } from '@/store';
import { BasketType } from '@/enums';
import BasketEmpty from '@/ui/views/checkout/BasketEmpty.vue';
import BasketTitle from '@/ui/views/checkout/BasketTitle.vue';
import BasketAddressSelectorB2B from '@/ui/views/checkout/BasketAddressSelectorB2B.vue';
import BasketSummaryB2B from '@/ui/views/checkout/BasketSummaryB2B.vue';
import QuoteBasketLineItemsB2B from '@/ui/views/checkout/QuoteBasketLineItemsB2B.vue';
import QuoteBasketOrderReferenceB2B from '@/ui/views/checkout/QuoteBasketOrderReferenceB2B.vue';
import LpButton from '@/ui/shared/LpButton.vue';
import UpdateOrderReferenceWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateOrderReferenceWebRequest;
import BasketViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Business.BasketViewModel;
import ValidationResultViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.ValidationResultViewModel;
import SaveCheckoutViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Business.SaveCheckoutViewModel;
import QuoteBasketPageViewModel = Vertica.LouisPoulsen.Application.Content.Pages.Basket.Business.QuoteBasketPageViewModel;
import CustomDeliveryAddressViewObject = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Business.CustomDeliveryAddressViewObject;
import SaveCheckoutB2BWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.Business.SaveCheckoutB2BWebRequest;
import { useImpersonation } from '@/store/impersonation.composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteBasketB2B',
  props: {
    model: null
  },
  setup(__props: any) {

const props = __props as {model: QuoteBasketPageViewModel}

const quoteBasket = computed<BasketViewModel>(() => store.getters['quotebasket/quoteBasket']);
const logoutUrl = computed<string>(() => store.getters['app/logoutUrl']);



const { isImpersonating } = useImpersonation();

function fetchQuoteBasket() {
    store.dispatch('quotebasket/fetchQuoteBasket');
}
function updateOrderReference(request: UpdateOrderReferenceWebRequest) {
    store.dispatch('quotebasket/updateOrderReference', request);
}
function ensureValidForCheckout() : Promise<ValidationResultViewModel> {
    return store.dispatch('quotebasket/ensureValidForCheckout');
}
function submitQuote(request: SaveCheckoutB2BWebRequest) : Promise<SaveCheckoutViewModel> {
    return store.dispatch('checkoutb2b/submitQuote', request);
}

function submitAddToBasket() {
    return store.dispatch('basket/addQuotedProductsToBasket');
}
const customDeliveryAddress = ref<CustomDeliveryAddressViewObject>(props.model.customDeliveryAddress);
const selectedDeliveryAddressId = ref<string>(props.model.deliveryAddressId);

fetchQuoteBasket();

const basketHasItems = computed<boolean>(() => {
    const lineItemCount = quoteBasket.value.lineItems.length;
    return lineItemCount !== 0;
});

async function addQuoteToBasket() {
    showSpinner.value = true;
    await submitAddToBasket().then((response) => {
        if (response === 'OK') {
            showSpinner.value = false;
            window.location.href = `${props.model.dashBoardUrl}?expand=basket`;
        }
        return response;
    }).catch((error) => {
        showSpinner.value = false;
        validationMessage.value = error;
        return false;
    });
}

function onOrderReferenceChange(texts: any) {
    const request : UpdateOrderReferenceWebRequest = {
        orderReference: texts.orderReference,
        customerReference: texts.customerReference,
        orderComment: texts.comment,
        basketType: BasketType.Quotation as any
    };
    updateOrderReference(request);
}

function onSubmit() {
    if (document.activeElement) {
        const input = (document.activeElement as HTMLInputElement) || (document.activeElement as HTMLButtonElement);
        if (input.type === 'text') {
            input.blur();
            return false;
        }

        if (document.activeElement.classList.contains('add-quote')) {
            return false;
        }
    }

    showSpinner.value = true;
    validationMessage.value = null;

    ensureValidForCheckout().then((response : ValidationResultViewModel) => {
        if (!response.isValid) {
            validationMessage.value = response.message;
        } else {
            submitQuote(quoteRequest.value).then(response => {
                window.location.href = response.redirectUrl;
            });
        }
    }).catch(() => {
        validationMessage.value = 'unknown error';
    }).finally(() => {
        showSpinner.value = false;
    });
}

const quoteRequest = computed<SaveCheckoutB2BWebRequest>(() => {
    return {
        basketType: BasketType.Quotation as any,
        customDeliveryAddress: selectedDeliveryAddressId.value ? null : customDeliveryAddress.value,
        deliveryAddressId: selectedDeliveryAddressId.value
    };
});

const showSpinner = ref<boolean>(false);
const validationMessage = ref<string>(null);

return { __sfc: true,quoteBasket, logoutUrl, props, isImpersonating, fetchQuoteBasket, updateOrderReference, ensureValidForCheckout, submitQuote, submitAddToBasket, customDeliveryAddress, selectedDeliveryAddressId, basketHasItems, addQuoteToBasket, onOrderReferenceChange, onSubmit, quoteRequest, showSpinner, validationMessage, BasketEmpty, BasketTitle, BasketAddressSelectorB2B, BasketSummaryB2B, QuoteBasketLineItemsB2B, QuoteBasketOrderReferenceB2B, LpButton }
}

})